import { createLookupStore, type LookupStore } from '@botto/core';
import { smsClient } from '../api/client';
import type { Direction } from '../api/types';

export { getSmppHostsLookup, type SmppHost } from './smppHosts';

let _directions: LookupStore<Direction> | undefined;

async function fetchAllDirections(): Promise<Direction[]> {
  const { data, error } = await smsClient.GET('/directions/', {
    params: { query: { offset: 0, limit: 1000, 'sort.name': 'name', 'sort.direction': 'asc' } },
  });
  if (error) throw error;
  return data?.items ?? [];
}

export function getDirectionsLookup(): LookupStore<Direction> {
  if (!_directions) {
    _directions = createLookupStore<Direction>(fetchAllDirections, {
      idField: 'id',
      labelField: 'name',
      format: (d) => {
        const parts = [d.name, d.operator, d.country_iso].filter(Boolean);
        return parts.length > 0 ? parts.join(' · ') : `#${d.id}`;
      },
    });
  }
  return _directions;
}
